import { render, staticRenderFns } from "./Swipe.vue?vue&type=template&id=c6d352e0&scoped=true&"
import script from "./Swipe.vue?vue&type=script&lang=ts&"
export * from "./Swipe.vue?vue&type=script&lang=ts&"
import style0 from "./Swipe.vue?vue&type=style&index=0&id=c6d352e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d352e0",
  null
  
)

export default component.exports